import type { ListItemButtonOwnProps } from '@mui/material';
import type { ReactNode } from 'react';
import create from 'zustand';

export enum MainMenuKeys {
  RecentPatients = 'Recent Patients',
  Patients = 'Patients',
  MedicationManagement = 'Medication Management',
  CareManagement = 'Care Management',
  TimesheetsInvoicesAdmin = 'Timesheets & Invoices Admin',
  TransitionalCareManagement = 'Transitional Care Management',
  Reports = 'Reports',
  Provider = 'Provider',
  UserAdmin = 'User Administration',
  Administration = 'Administration',
  SystemAdmin = 'System Administration',
  SystemCompany = 'System Pharmacy',
  QuickLinksAdmin = 'Quick Links Admin',
  ProvidersAdmin = 'Providers Admin'
}

export type MenuSectionType = {
  title: ReactNode;
  options: MainMenuItem[];
  hidden?: boolean;
};

export type MainMenuItem = {
  /** Stable id from the menu catalog.  Absent on the dynamically built recent-patient items. */
  key?: string;
  navigatePath: string;
  icon: ReactNode;
  label: string;
  hidden: boolean;
  disabled?: boolean;
  ribbonPosition?: number;
  buttonProps?: ListItemButtonOwnProps;
};

export type AppFrameStore = {
  contentScrollPosition: number;
  setContentScrollPosition: (value: number) => void;
  goTop: boolean;
  setGoTop: (value: boolean) => void;
  mainMenuItems: Map<MainMenuKeys, MenuSectionType>;
  setMainMenuItems: (value: Map<MainMenuKeys, MenuSectionType>) => void;
};

export const useAppFrameStore = create<AppFrameStore>(set => ({
  contentScrollPosition: 0,
  goTop: false,
  setContentScrollPosition: value => set(() => ({ contentScrollPosition: value })),
  setGoTop: value => set(() => ({ goTop: value })),
  mainMenuItems: new Map(),
  setMainMenuItems: value => set(() => ({ mainMenuItems: value }))
}));
